// 57
export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        id: 1,
        _name: "CSidebarNavItem",
        name: "Print",
        to: "/print-tags",
        icon: "cil-file",
        key: "print",
      },
        {
        id: 1,
        _name: "CSidebarNavItem",
        name: "Print Non-Serial",
        to: "/print-tags-nonserial",
        icon: "cil-file",
        key: "print-nonserial",
      },
      {
        id: 2,
        _name: "CSidebarNavItem",
        name: "Print Cover Sheet",
        to: "/cover-sheet",
        icon: "cil-file",
        key: "cover-sheet",
      },
      {
        id: 3,
        _name: "CSidebarNavDropdown",
        name: "Setting",
        icon: "cil-settings",
        key: "Setting",
        _children: [
          {
            id: 4,
            _name: "CSidebarNavItem",
            name: "Setting Print Tag Serial",
            icon: "cil-settings",
            key: "setting-serial",
            to: "/setting-serial",
          },
          {
            id: 5,
            _name: "CSidebarNavItem",
            name: "Setting Print Tag Non-Serial",
            icon: "cil-settings",
            key: "setting-non-serial",
            to: "/setting-non-serial",
          },
          {
            id: 6,
            _name: "CSidebarNavItem",
            name: "Setting Cover Sheet",
            icon: "cil-settings",
            key: "setting-cover-sheet",
            to: "/setting-cover-sheet",
          },
        ],
      },
    ],
  },
];
